import axios from 'axios'
export default {
    index(paginacion) {

    },
    getCajaDetalle(cajaId) {
        return axios.get(`sucursales/detalle/cajas/${cajaId}`);
    },
    fetch() {

        return axios.get(`/sucursales/sucursales`)
    },
    getInfo() {
        var url = `/sucursales/sucursal`
        return axios.get(url)
    },
    getArqueos(cajaId) {
        return axios.get(`sucursales/cajas/${cajaId}`);

    },
    getArqueoDetalle(arqueoId) {
        return axios.get(`sucursales/arqueos/${arqueoId}/detalle`);

    },
    validate(sucursal_uuid) {
        const url = `/sucursales/validate/${sucursal_uuid}`;
        return axios.get(url)
    },
    validate_caja() {
        var url = `/sucursales/caja/validate`
        return axios.get(url)
    },
    // SucursalesAPI.js
    fetchConfig(uuid = null) {
        // Si viene el uuid, lo agregamos como parámetro ?uuid=...
        // Si no, enviamos un objeto vacío
        console.log("uuid recibido:", uuid);

        const params = uuid ? { uuid } : {};
        console.log();
        

        return axios.get(`/sucursales/configuracion/`, { params });
    },
    fetchParametros() {

        var url = `/sucursales/tipo-parametro`
        return axios.get(url)
    },
    getCaja(caja_id) {

        return axios.get(`/sucursales/cajas/${caja_id}`)
    },
    getCajaPorArqueo() {
        return axios.get(`/sucursales/mi_caja`)

    },
    getArqueoVigente() {
        return axios.get(`/sucursales/arqueo`)
    },


    show(uuid) {
        return axios.get(`/sucursales/${uuid}`)

    },

    update(id, data) {

    },


}